import google from './google';
import rownd from './rownd';

export const providers = [
    rownd,
    google,
]